// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__657UK","header":"styles_header__+qKt3","content":"styles_content__Un7d+","logo":"styles_logo__MhDLM"};